




























































































import { Component, Vue, Provide } from "vue-property-decorator";
import Vuex from 'vuex';
import LoadPanel from "./components/LoadPanel.vue";

// Servicios
import { logService } from '@/services/LogService';
import { toastService } from '@/services/ToastService';
import { authService } from './services/AuthService';
import { eventService } from "./services/EventService";  
import { UsuarioService } from './services/UsuarioService';

import { Sorteo } from './model/Sorteo';
import { CambiarPasswordDTO } from './model/CambiarPasswordDTO';

Vue.use(Vuex);

@Component({
  components: { LoadPanel }
})
export default class App extends Vue {
  drawer: boolean = true;
  dialog: boolean = false;
  visible: boolean = false;

  isAuthenticated: any;
  isAdmin: any;

  usuarioService: any | UsuarioService = new UsuarioService();
  passwordOld: string ="";
  password: string ="";
  passwordConfirmacion: string ="";
  valid: boolean = false;
  passwordRulesOld: any = [(v: any) => !!v || 'Campo requerido'];
  passwordRules: any = [(v: any) => !!v || 'Campo requerido',
            (v: any) => (v && v.length >= 6) || 'El password debe tener más de 6 caracteres.']
  passwordConfirmacionRules: any = [(v: any) => !!v || 'Campo requerido',
            (v: any) => (v && this.checkPassword(v)) || 'Debe coincidir con la contraseña.']

  created(){
    this.isAuthenticated = authService.isAuthenticated();
    this.isAdmin = authService.isAdmin();

    if(this.isAuthenticated){
      this.$router.replace('/');
    }else{
      this.$router.replace('/login');
    }

    eventService.on("401 Unauthorized", ()=>{
      logService.Info("401 Unauthorized","App.vue - created()");
      this.logout();
    })
    
  }
  logout(){
    logService.Info("Inicio","App.vue - logout()");
    authService.logout();
    window.location.href = "/";
  }

  checkPassword(v: any ){
    return v === this.password;
  }

  close() {
    this.visible = false;
    this.passwordOld = "";
    this.password = "";
    this.passwordConfirmacion = "";
  }

  cambiarPassword() {
    logService.Info("Inicio","App.vue - cambiarPassword()");
    if ((<any>this.$refs.formPass).validate()) {
      let dto = new CambiarPasswordDTO();
      dto.Password = this.passwordOld;
      dto.NewPassword = this.password;
      this.valid = true;
      eventService.emit("LoadPanel", true);
      
      this.usuarioService.cambiarPassword(authService.getUser().Id, dto).then((res: any) => {

        if(res.Message !== null && res.Message !== ""){
          logService.Info(res.Message,"App.vue - ()");
          toastService.warning(res.Message);
        }else{
          logService.Info("Contraseña cambiada correctamente.","App.vue - ()");
          toastService.success("Contraseña cambiada correctamente.");
          
          (<any>this.$refs.formPass).reset();
          this.close();
        }
        eventService.emit("LoadPanel", false);
      });
    }
  }
}
